import axios from "axios";
import { getAccessToken, getRefreshToken,saveToken, logout, getUsername, getUserRole } from "@/utils/authUtils";
import logger from "@/utils/logger";


// Create axios instance with interceptors
const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API + "",
});

// Request interceptor to add auth token to requests
axiosInstance.interceptors.request.use(
  (config) => {

    if (!config.url.includes("/log")) {
      logger.info("API Request: " + config.url);
    } 

    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    logger.error("Request Interceptor Error: " + error);
    return Promise.reject(error);
  }
);
// Auto-refresh token when accessToken expires
axiosInstance.interceptors.response.use(
  (response) => 
    {
      //added for loggings
    if (!response.config.url.includes("/log")) {
      logger.info("API Success: " + response.config.url);
    }
    //end

    return response;
  },
  async (error) => {
    //added for loggings
    if (!error.config?.url.includes("/log")) {
      logger.error("API Error: " + error);
    }
    //end

    const originalRequest = error.config;

    // If unauthorized (401) and not retried yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = getRefreshToken();
      const username = getUsername();
      const role = getUserRole();
      if (!refreshToken) {
        logout();
        window.location.href = "/login";
        return Promise.reject(error);
      }
      try {
        const response = await axios.post(`${axiosInstance.baseURL}/refresh`, {
          refreshToken,
        });

        const newAccessToken = response.data.accessToken;
        const newRefreshToken = response.data.refreshToken;
        // Update stored token
        saveToken(newAccessToken, newRefreshToken, username, role);

        // Retry original request
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        console.error("Refresh token failed:", refreshError);
        logout();
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);
// // Response interceptor to handle token expiration
// axiosInstance.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     if (error.response && error.response.status === 401) {
//       // Token expired or invalid, logout user
//       logout();
//       // Emit event for components to handle redirect
//       window.dispatchEvent(new CustomEvent('axios:unauthorized'));
//     }
//     return Promise.reject(error);
//   }
// );

export default axiosInstance;